<prlw-last-deals-table-ui
  [data]="data$ | async"
  [columns]="columns$ | async"
  [gridSize]="gridSize$ | async"
  [loading]="loading$ | async"
  [buttonLoading]="buttonLoading$ | async"
  [overflows]="overflows$ | async"
  [isExpanded]="isExpanded"
  [fetchMoreLabel]="fetchMoreLabel$ | async"
  [noDealsAnymore]="noDealsAnymore"
  (initResizeObserver)="initResizeObserver($event)"
  (setScrollHorizontalPosition)="setScrollHorizontalPosition($event)"
  (setScrollVerticalPosition)="setScrollVerticalPosition($event)"
  (eventFetchMore)="handleFetchMore()"
></prlw-last-deals-table-ui>
